import { useEffect, useState } from 'react';
import { get } from '../../services/apiController';
import { toast } from 'react-toastify';
import moment from 'moment';
import { useParams } from 'react-router-dom';

const IndentPrint = (props) => {
  const [indent, setIndent] = useState([]);
  const params = useParams();
  const [factory, setFactory] = useState({});

  useEffect(() => {
    if (indent?.factoryId) {
      get('/branches/?id=' + indent.factoryId).then((branch) => {
        if (branch.data.rows.length) {
          setFactory(branch.data.rows[0]);
        }
      });
    }
  }, [indent?.factoryId]);

  function getIndent() {
    try {
      get(`/inv/indents/?id=${params.id}`).then((response) => {
        setIndent(response.data.rows[0]);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  }

  useEffect(() => {
    getIndent();
  }, [params?.id]);

  return (
    <div className="container">
      <div className="row">
        {indent ? (
          <div className="col-xs-12">
            <div className="row ">
              <div className="col-xs-12 text-center font-weight-bold">
                <h2>Kanti Sweets</h2>
                <h4>
                  {factory?.name}
                  <br />
                  {factory?.address}
                </h4>
              </div>
            </div>
            <table id="example1" className="table table-bordered text-center">
              <thead style={{ backgroundColor: '#90c', color: 'white' }}>
                <tr>
                  <th rowSpan="2" style={{ textAlign: 'center' }}>
                    Indent Number
                  </th>
                  <th rowSpan="2" style={{ textAlign: 'center' }}>
                    {' '}
                    Factory
                  </th>
                  <th rowSpan="2" style={{ textAlign: 'center' }}>
                    {' '}
                    Order Type
                  </th>
                  <th colSpan="3" style={{ textAlign: 'center' }}>
                    Order Details
                  </th>
                  <th rowSpan="2" style={{ textAlign: 'center' }}>
                    {' '}
                    Raised By
                  </th>
                  <th rowSpan="2" style={{ textAlign: 'center' }}>
                    {' '}
                    Created At
                  </th>
                </tr>
                <tr>
                  <th style={{ width: '150px', textAlign: 'center' }}>Item</th>
                  <th style={{ width: '150px', textAlign: 'center' }}>Quantity</th>
                  <th style={{ width: '150px', textAlign: 'center' }}>Vendor</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowspan="7">{indent?.indentNumber}</td>
                  <td rowspan="7">{indent?.Branch?.name}</td>
                  <td rowspan="7">{indent?.orderType}</td>
                  <td>{indent?.RawMaterialIndentDetails?.length > 0 && indent?.RawMaterialIndentDetails[0]?.Item?.name}</td>
                  <td>
                    {indent?.RawMaterialIndentDetails?.length > 0 &&
                      `${indent?.RawMaterialIndentDetails[0]?.quantity} (${indent?.RawMaterialIndentDetails[0]?.unit})`}
                  </td>
                  <td>{indent?.RawMaterialIndentDetails?.length > 0 && indent?.RawMaterialIndentDetails[0]?.VendorMaster?.name}</td>

                  <td rowspan="7">{indent?.User?.name}</td>
                  <td rowspan="7">{moment(indent?.createdAt).format('YYYY-MM-DD')}</td>
                </tr>
                {indent?.RawMaterialIndentDetails?.length > 0 &&
                  indent?.RawMaterialIndentDetails.map((detail, index) => {
                    if (index === 0) {
                      return null; // Skip rendering the first item
                    }
                    return (
                      <tr>
                        <td className="text-center">{detail.Item.name}</td>
                        <td className="text-center">{`${detail.quantity} (${detail.unit})`}</td>
                        <td className="text-center">{detail?.VendorMaster?.name}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        ) : (
          <h2 className="text-center p-5">No records Found</h2>
        )}
      </div>
    </div>
  );
};

export default IndentPrint;
